import { render, staticRenderFns } from "./PageEmployeeCreate.vue?vue&type=template&id=2050a200&"
import script from "./PageEmployeeCreate.vue?vue&type=script&lang=js&"
export * from "./PageEmployeeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports